<template>
    <div class="w-full h-1 overflow-hidden bg-white/10">
        <div class="h-full bg-primary animate-progress" />
    </div>
</template>

<style scoped>
    @keyframes progress {
        0% {
            transform: translateX(-100%);
            width: 30%;
        }
        50% {
            transform: translateX(50%);
            width: 50%;
        }
        100% {
            transform: translateX(200%);
            width: 30%;
        }
    }
    .animate-progress {
        animation: progress 1.5s ease-in-out infinite;
    }
</style>
